
    // this file was auto generated by python script
    import Mic from './Mic';
    export default Mic;
    